import { render, staticRenderFns } from "./alertComponent.vue?vue&type=template&id=5004e3ad"
import script from "./alertComponent.vue?vue&type=script&lang=js"
export * from "./alertComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports